module.exports = __webpack_public_path__ + "static/media/total-scheduled-payments-blue.5a137a02.svg";